export default __webpack_public_path__ + "394ccc08a5dcf531ef55c0ced058dcb0.png";